<template>
  <div class="sched-page" :class="device.desktop ? 'pa-6' : 'pa-0'">
    <v-row>
      <v-col cols="12">
        <v-card class="sched-card elevation-0">
          <div class="sched-toolbar">
            <div class="sched-toolbar__left">
              <div class="sched-toolbar__icon">
                <v-icon>mdi-calendar-clock</v-icon>
              </div>
              <div>
                <div class="sched-toolbar__title">Pesan Terjadwal</div>
                <div class="sched-toolbar__sub">
                  {{ records.length || 0 }} jadwal (sekali / harian)
                </div>
              </div>
            </div>
            <div class="sched-toolbar__actions">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Cari penerima / pesan..."
                single-line
                hide-details
                dense
                outlined
                color="#1f7a57"
                class="sched-search"
                clearable
              ></v-text-field>
              <v-btn icon class="sched-icon-btn" @click="loadRecords">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn class="sched-btn-primary" @click="openForm">
                <v-icon left small>mdi-plus</v-icon>
                Tambah Jadwal
              </v-btn>
            </div>
          </div>

          <v-data-table
            v-show="device.desktop"
            :headers="headers"
            :items="filtered"
            :items-per-page="25"
            class="sched-table"
            :loading="loading"
            loading-text="Memuat jadwal..."
            hide-default-footer
          >
            <template v-slot:item.schedule_type_label="{ item }">
              <span
                class="sched-badge"
                :class="item.schedule_type === 'daily' ? 'is-daily' : 'is-once'"
              >
                {{ item.schedule_type_label || 'Sekali' }}
              </span>
            </template>
            <template v-slot:item.next_run_label="{ value }">
              <span class="sched-time">{{ value || '—' }}</span>
            </template>
            <template v-slot:item.content="{ item }">
              <div class="sched-content">{{ item.content || '—' }}</div>
            </template>
            <template v-slot:item.status="{ item }">
              <span
                class="sched-status"
                :style="{ color: (item.status && item.status.color) || '#5d7268' }"
              >
                {{ (item.status && item.status.text) || '—' }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="item.schedule_type === 'daily'"
                icon
                small
                :title="item.recurrence_active ? 'Hentikan' : 'Aktifkan'"
                @click="toggleDaily(item)"
              >
                <v-icon small :color="item.recurrence_active ? '#1f7a57' : '#9aa8a0'">
                  {{ item.recurrence_active ? 'mdi-pause-circle-outline' : 'mdi-play-circle-outline' }}
                </v-icon>
              </v-btn>
              <v-btn icon small color="#c0392b" @click="removeItem(item)">
                <v-icon small>mdi-delete-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>

          <div v-show="!device.desktop" class="sched-mobile">
            <div
              v-for="item in filtered"
              :key="item.id"
              class="sched-mobile-card"
            >
              <div class="sched-mobile-card__top">
                <span
                  class="sched-badge"
                  :class="item.schedule_type === 'daily' ? 'is-daily' : 'is-once'"
                >
                  {{ item.schedule_type_label || 'Sekali' }}
                </span>
                <span class="sched-time">{{ item.next_run_label || '—' }}</span>
              </div>
              <div class="sched-mobile-card__body">{{ item.content || '—' }}</div>
              <div class="sched-mobile-card__meta">
                {{ item.sender_number }} → {{ item.recieve_number }}
              </div>
              <div class="sched-mobile-card__actions">
                <v-btn
                  v-if="item.schedule_type === 'daily'"
                  text
                  small
                  color="#1f7a57"
                  @click="toggleDaily(item)"
                >
                  {{ item.recurrence_active ? 'Hentikan' : 'Aktifkan' }}
                </v-btn>
                <v-btn text small color="#c0392b" @click="removeItem(item)">Hapus</v-btn>
              </div>
            </div>
            <div v-if="!filtered.length" class="sched-empty">Belum ada jadwal</div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="formOpen"
      max-width="560"
      persistent
      :fullscreen="device.mobile"
      content-class="sched-dialog"
    >
      <v-card class="sched-dialog-card">
        <div class="sched-dialog-header">
          <div class="sched-dialog-header__copy">
            <v-icon class="mr-2">mdi-calendar-plus</v-icon>
            Tambah Pesan Terjadwal
          </div>
          <v-btn icon dark small @click="formOpen = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="sched-dialog-body">
          <div class="sched-field-label">Nomor Pengirim</div>
          <v-select
            outlined
            dense
            hide-details="auto"
            color="#1f7a57"
            v-model="form.sender_number"
            :items="senders"
            class="sched-field mb-4"
            prepend-inner-icon="mdi-whatsapp"
          ></v-select>

          <div class="sched-field-label">Nomor Penerima</div>
          <v-select
            outlined
            dense
            hide-details="auto"
            color="#1f7a57"
            v-model="form.recieve_number"
            :items="recieves"
            class="sched-field mb-4"
            prepend-inner-icon="mdi-account-outline"
          ></v-select>

          <div class="sched-field-label">Jenis Jadwal</div>
          <v-select
            outlined
            dense
            hide-details="auto"
            color="#1f7a57"
            v-model="form.schedule_type"
            :items="scheduleTypes"
            class="sched-field mb-4"
            prepend-inner-icon="mdi-calendar-range"
          ></v-select>

          <div v-if="form.schedule_type === 'once'" class="sched-field-label">
            Waktu Kirim
          </div>
          <v-text-field
            v-if="form.schedule_type === 'once'"
            outlined
            dense
            hide-details="auto"
            color="#1f7a57"
            type="datetime-local"
            v-model="form.scheduled_at"
            class="sched-field mb-4"
            prepend-inner-icon="mdi-clock-outline"
          ></v-text-field>

          <div v-else class="sched-field-label">Jam Harian</div>
          <v-text-field
            v-if="form.schedule_type === 'daily'"
            outlined
            dense
            hide-details="auto"
            color="#1f7a57"
            type="time"
            v-model="form.recurrence_time"
            class="sched-field mb-2"
            prepend-inner-icon="mdi-clock-outline"
          ></v-text-field>
          <div v-if="form.schedule_type === 'daily'" class="sched-hint mb-4">
            Pesan dikirim setiap hari pada jam ini (zona waktu Jakarta).
          </div>

          <div class="sched-field-label">Pesan</div>
          <v-textarea
            outlined
            color="#1f7a57"
            hide-details="auto"
            rows="4"
            v-model="form.content"
            class="sched-field"
            placeholder="Isi pesan terjadwal..."
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="sched-dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text class="sched-btn-ghost" @click="formOpen = false">Batal</v-btn>
          <v-btn class="sched-btn-primary" :loading="saving" @click="submitForm">
            Simpan Jadwal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "PesanTerjadwal",
  data: () => ({
    search: "",
    loading: false,
    saving: false,
    records: [],
    senders: [],
    recieves: [],
    formOpen: false,
    form: {
      sender_number: null,
      recieve_number: null,
      schedule_type: "once",
      scheduled_at: "",
      recurrence_time: "08:00",
      content: "",
      type: "text",
      process: "schedule",
    },
    scheduleTypes: [
      { text: "Sekali", value: "once" },
      { text: "Harian", value: "daily" },
    ],
    headers: [
      { text: "Jenis", value: "schedule_type_label", width: 110 },
      { text: "Jadwal Berikutnya", value: "next_run_label", width: 170 },
      { text: "Pengirim", value: "sender_number" },
      { text: "Penerima", value: "recieve_number" },
      { text: "Pesan", value: "content" },
      { text: "Status", value: "status", width: 130 },
      { text: "", value: "actions", sortable: false, width: 100, align: "center" },
    ],
  }),
  computed: {
    ...mapState(["http", "device", "snackbar", "theme"]),
    filtered() {
      if (!this.search) return this.records || [];
      const q = this.search.toLowerCase();
      return (this.records || []).filter((item) => {
        return (
          String(item.content || "").toLowerCase().includes(q) ||
          String(item.recieve_number || "").toLowerCase().includes(q) ||
          String(item.sender_number || "").toLowerCase().includes(q)
        );
      });
    },
  },
  created() {
    this.$store.dispatch("setPage", {
      crud: false,
      dataUrl: "api/pesan/outbox-scheduled",
      title: "PESAN TERJADWAL",
      subtitle: "Jadwal sekali atau harian",
      showtable: false,
      breadcrumbs: [
        { text: "Pesan", disabled: true, href: "" },
        { text: "Pesan Terjadwal", disabled: false, href: "" },
      ],
      actions: {
        refresh: true,
        add: true,
        edit: false,
        delete: true,
      },
    });
    this.loadCombos();
    this.loadRecords();
  },
  methods: {
    toLocalInputValue(date) {
      const pad = (n) => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },
    async loadCombos() {
      try {
        const [senders, contacts] = await Promise.all([
          this.http.get("api/combo/pengaturan"),
          this.http.get("api/combo/contact"),
        ]);
        this.senders = senders.data || [];
        this.recieves = contacts.data || [];
      } catch (e) {}
    },
    async loadRecords() {
      this.loading = true;
      try {
        const { data } = await this.http.get("api/pesan/outbox-scheduled");
        this.records = Array.isArray(data) ? data : [];
      } catch (e) {
        this.records = [];
      } finally {
        this.loading = false;
      }
    },
    openForm() {
      const soon = new Date(Date.now() + 10 * 60 * 1000);
      this.form = {
        sender_number: (this.senders[0] && this.senders[0].value) || null,
        recieve_number: null,
        schedule_type: "once",
        scheduled_at: this.toLocalInputValue(soon),
        recurrence_time: "08:00",
        content: "",
        type: "text",
        process: "schedule",
      };
      this.formOpen = true;
    },
    async submitForm() {
      if (!this.form.sender_number || !this.form.recieve_number) {
        this.snackbar.color = "orange";
        this.snackbar.text = "Pilih pengirim dan penerima";
        this.snackbar.state = true;
        return;
      }
      if (!(this.form.content || "").trim()) {
        this.snackbar.color = "orange";
        this.snackbar.text = "Isi pesan terlebih dahulu";
        this.snackbar.state = true;
        return;
      }
      if (this.form.schedule_type === "once" && !this.form.scheduled_at) {
        this.snackbar.color = "orange";
        this.snackbar.text = "Pilih waktu pengiriman";
        this.snackbar.state = true;
        return;
      }
      if (this.form.schedule_type === "daily" && !this.form.recurrence_time) {
        this.snackbar.color = "orange";
        this.snackbar.text = "Pilih jam harian";
        this.snackbar.state = true;
        return;
      }

      const payload = {
        sender_number: this.form.sender_number,
        recieve_number: this.form.recieve_number,
        type: "text",
        content: this.form.content.trim(),
        process: "schedule",
        schedule_type: this.form.schedule_type,
        scheduled_at:
          this.form.schedule_type === "once"
            ? new Date(this.form.scheduled_at).toISOString()
            : null,
        recurrence_time:
          this.form.schedule_type === "daily" ? this.form.recurrence_time : null,
      };

      try {
        this.saving = true;
        const { data } = await this.http.post("api/pesan/outbox", payload);
        if (data && data.success === false) {
          this.snackbar.color = "red";
          this.snackbar.text = data.message || "Gagal menyimpan jadwal";
          this.snackbar.state = true;
          return;
        }
        this.snackbar.color = this.theme.color || "green";
        this.snackbar.text = (data && data.message) || "Jadwal tersimpan";
        this.snackbar.state = true;
        this.formOpen = false;
        await this.loadRecords();
      } catch (e) {
        this.snackbar.color = "red";
        this.snackbar.text = "Gagal menyimpan jadwal";
        this.snackbar.state = true;
      } finally {
        this.saving = false;
      }
    },
    async toggleDaily(item) {
      try {
        const { data } = await this.http.post(
          `api/pesan/outbox-scheduled/${item.id}/toggle`,
          { active: !item.recurrence_active }
        );
        this.snackbar.color = data && data.success === false ? "red" : "green";
        this.snackbar.text = (data && data.message) || "Status diperbarui";
        this.snackbar.state = true;
        await this.loadRecords();
      } catch (e) {
        this.snackbar.color = "red";
        this.snackbar.text = "Gagal mengubah status";
        this.snackbar.state = true;
      }
    },
    async removeItem(item) {
      const ok = await this.$confirm({
        title: "Hapus Jadwal",
        text: "Hapus jadwal ini?",
        confirmText: "Ya, Hapus",
        cancelText: "Batal",
        danger: true,
      });
      if (!ok) return;
      try {
        await this.http.delete(`api/pesan/outbox/${item.id}`);
        this.snackbar.color = "green";
        this.snackbar.text = "Jadwal dihapus";
        this.snackbar.state = true;
        await this.loadRecords();
      } catch (e) {
        this.snackbar.color = "red";
        this.snackbar.text = "Gagal menghapus";
        this.snackbar.state = true;
      }
    },
  },
};
</script>

<style scoped>
.sched-page {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
}
.sched-card {
  border-radius: 14px !important;
  border: 1px solid var(--gw-line);
  overflow: hidden;
  background: #fff !important;
}
.sched-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 1.15rem;
  background: linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}
.sched-toolbar__left {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}
.sched-toolbar__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
}
.sched-toolbar__icon .v-icon {
  color: #0b3d2e !important;
}
.sched-toolbar__title {
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
}
.sched-toolbar__sub {
  font-size: 0.82rem;
  opacity: 0.85;
}
.sched-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.sched-search {
  max-width: 260px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 10px;
}
.sched-search >>> .v-input__slot {
  min-height: 36px !important;
}
.sched-icon-btn {
  color: #fff !important;
}
.sched-btn-primary {
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5) !important;
  color: #0b3d2e !important;
  font-weight: 700 !important;
  text-transform: none !important;
  border-radius: 10px !important;
}
.sched-table {
  background: #fff;
}
.sched-badge {
  display: inline-block;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
}
.sched-badge.is-daily {
  background: #e8f7ef;
  color: #0d4a36;
}
.sched-badge.is-once {
  background: #eef2f7;
  color: #3a4a5a;
}
.sched-time {
  font-size: 0.85rem;
  color: var(--gw-forest);
  font-weight: 600;
}
.sched-content {
  max-width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sched-status {
  font-size: 0.82rem;
  font-weight: 600;
}
.sched-mobile {
  padding: 0.85rem;
  display: grid;
  gap: 0.75rem;
}
.sched-mobile-card {
  border: 1px solid var(--gw-line);
  border-radius: 12px;
  padding: 0.9rem;
}
.sched-mobile-card__top {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}
.sched-mobile-card__body {
  margin-top: 0.5rem;
  color: var(--gw-ink);
}
.sched-mobile-card__meta {
  margin-top: 0.35rem;
  font-size: 0.8rem;
  color: var(--gw-muted);
}
.sched-mobile-card__actions {
  margin-top: 0.5rem;
  display: flex;
  gap: 0.25rem;
}
.sched-empty {
  text-align: center;
  color: var(--gw-muted);
  padding: 2rem 1rem;
}
.sched-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1rem;
  background: linear-gradient(175deg, #0b3d2e, #0f5c45);
  color: #fff;
}
.sched-dialog-header__copy {
  display: flex;
  align-items: center;
  font-weight: 700;
}
.sched-dialog-body {
  padding: 1.15rem !important;
}
.sched-field-label {
  margin-bottom: 0.35rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--gw-forest);
}
.sched-hint {
  font-size: 0.8rem;
  color: var(--gw-muted);
}
.sched-dialog-actions {
  padding: 0.75rem 1rem !important;
}
.sched-btn-ghost {
  text-transform: none !important;
  color: var(--gw-muted) !important;
}
</style>
